export default __webpack_public_path__ + "static/media/example.04dda983.png";